export const DRILL_TYPE_LIST = [
//     {
//     "key": "READING",
//     "id": 1,
//     "name": "扩展阅读"
// },{
//     "key": "VIDEO",
//     "id": 2,
//     "name": "视频题"
// },
{
    "key": "SINGLE_CHOICE_QUESTION_DRILL",
    "id": 100,
    "name": "选择题",
    "subType": [{
        "key": "SINGLE_CHOICE_QUESTION_DRILL",
        "id": 101,
        "name": "单项选择题"
    },{
        "key": "MULTIPLE_CHOICE_QUESTION_DRILL",
        "id": 102,
        "name": "多项选择题"
    },{
        "key": "TRUE_FALSE_QUESTION_DRILL",
        "id": 103,
        "name": "判断题"
    }]
},{
    "key": "GAP_FILLING_DRILL",
    "id": 200,
    "name": "填空题",
    "subType": [{
        "key": "GAP_FILLING_DRILL",
        "id": 201,
        "name": "看文字填空题"
    },{
        "key": "LISTENING_FILLING_DRILL",
        "id": 202,
        "name": "听录音填空题"
    }]
},{
    "key": "SHORT_ANSWER_DRILL",
    "id": 300,
    "name": "问答题",
    "subType": [{
        "key": "SHORT_ANSWER_DRILL",
        "id": 301,
        "name": "简答题"
    },{
        "key": "TRANSLATION_DRILL",
        "id": 302,
        "name": "翻译题"
    }]
},{
    "key": "DIALOGUE_DRILL",
    "id": 400,
    "name": "对话题",
    "subType": [{
        "key": "DIALOGUE_DRILL_1",
        "id": 401,
        "name": "英文录音"
    },{
        "key": "DIALOGUE_DRILL_1",
        "id": 403,
        "name": "中文录音（不可打分）"
    }]
},{
    "key": "READBACK_DRILL",
    "id": 500,
    "name": "复诵题",
    "subType": [{
        "key": "READING",
        "id": 501,
        "name": "看文字朗读"
    },{
        "key": "REPEAT",
        "id": 502,
        "name": "听录音复诵"
    },{
        "key": "ORAL",
        "id": 503,
        "name": "口译"
    }]
},{
    "key": "PASSAGE_CHOICE_DRILL",
    "id": 600,
    "name": "理解题",
    "subType": [{
        "key": "READING_PASSAGE_CHOICE_DRILL",
        "id": 601,
        "name": "阅读理解题"
    },{
        "key": "LISTENING_PASSAGE_CHOICE_DRILL",
        "id": 602,
        "name": "听力理解题"
    }]
},{
    "key": "SEQUENCING_DRILL",
    "id": 700,
    "name": "排序题",
    "subType": [{
        "key": "SEQUENCING_DRILL",
        "id": 701,
        "name": "排序题"
    }]
},{
    "key": "PASSAGE_SEQUENCING_DRILL",
    "id": 800,
    "name": "听力理解排序题",
    "subType": [{
        "key": "PASSAGE_SEQUENCING_DRILL",
        "id": 801,
        "name": "听力理解排序题"
    }]
}]

export let DRILL_TYPE_MAP = {}
DRILL_TYPE_LIST.forEach(item => {
    DRILL_TYPE_MAP[item.id] = item
})

export let SUB_DRILL_TYPE_LIST = []
DRILL_TYPE_LIST.forEach(item => {
    if(item.subType){
        SUB_DRILL_TYPE_LIST = SUB_DRILL_TYPE_LIST.concat(item.subType)
    }
})


export const SECTION_TYPE_LIST = [{
    id: 0,
    name: '课时练习',
    key: "0",
  },{
    id: 1,
    name: '扩展阅读',
    key: "1",
  },{
    id: 2,
    name: '扩展视频',
    key: "2",
  },{
    id: 4,
    name: 'AI情景对话',
    key: "4",
  },{
    id: 3,
    name: '课文录音',
    key: "3",
  },{
    id: 5,
    name: '考试',
    key: "5",
  }]

export let SECTION_TYPE_MAP = {}
SECTION_TYPE_LIST.forEach(item => {
    SECTION_TYPE_MAP[item.id] = item
})